import { UserScopeT, ScopeT } from 'business/definitions';

export const MAX_CHIP_TO_DISPLAY = 15;
/**
 * Checks if the user has a restricted access to the scope but without any block.
 * @param {UserScopeT[] | undefined} userScopes - Scopes of the user
 * @param {ScopeT} scope - The scope configuration
 * @returns {boolean}
 */
export const isScopeRestrictedWithoutBlock = (
    userScopes: UserScopeT[],
    scope: ScopeT,
): boolean => {
    const userScope = userScopes.find((uScope) => uScope.name === scope.name);
    if (!userScope || userScope.accessType !== 'restricted') return false;
    return !userScope.blocks.length;
};
